import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-657aa0f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "contentList" }
const _hoisted_2 = ["data-item"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircularProgressBar = _resolveComponent("CircularProgressBar")!
  const _component_ContentItem = _resolveComponent("ContentItem")!

  return (_openBlock(), _createElementBlock("ol", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (content, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: `content-item-${index}`,
        "data-item": content.id
      }, [
        _createVNode(_component_ContentItem, {
          title: content.title,
          length: _ctx.formatContentLength(content),
          "is-active": content.id === _ctx.currentContent?.id,
          type: content.type,
          "is-released": content.isReleased,
          "is-blocked": content.isBlocked,
          "is-in-correction": content.exercise?.status?.questionnaire?.inCorrection,
          tabindex: (content.isBlocked || !content.isReleased) ? -1 : 0,
          onClick: ($event: any) => (_ctx.onClickContent(content)),
          onKeydown: ($event: any) => (_ctx.onKeyDownContent($event, content))
        }, {
          "circular-progress": _withCtx(() => [
            _createVNode(_component_CircularProgressBar, {
              checked: content.status.progress === 100,
              blocked: content.isBlocked,
              progress: content.status.progress,
              upcoming: !content.isReleased,
              class: _normalizeClass({ disable: !content.isReleased || content.isBlocked })
            }, null, 8, ["checked", "blocked", "progress", "upcoming", "class"])
          ]),
          _: 2
        }, 1032, ["title", "length", "is-active", "type", "is-released", "is-blocked", "is-in-correction", "tabindex", "onClick", "onKeydown"])
      ], 8, _hoisted_2))
    }), 128))
  ], 512))
}